import styled from "styled-components";

export const BlurBox = styled.div`
	display: flex;
	padding: 1rem 1.25rem;
	justify-content: space-between;
	align-items: center;

	border-radius: 12px;
	background: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(12px);
`;
